import React, { useRef } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { PieChartHeader } from "./PieChartHeader";
import { PieChartCanvas } from "./PieChartCanvas";
import { usePieChartExport } from "./hooks/usePieChartExport";
import type { PieChartData } from "@/lib/chat/parsePieChartBlock";

interface PieChartModalProps {
  open: boolean;
  onClose: () => void;
  data: PieChartData;
}

export const PieChartModal: React.FC<PieChartModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const exportRef = useRef<HTMLDivElement>(null);
  const { exportPNG } = usePieChartExport(exportRef, data.title);

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[90vh] w-[95vw] max-w-none flex-col gap-0 p-0 sm:rounded-2xl [&>button:last-child]:hidden">
        <div ref={exportRef} className="flex flex-col flex-1 min-h-0">
          <PieChartHeader
            title={data.title}
            mode="expanded"
            onDownload={exportPNG}
            onToggleExpand={onClose}
          />
          <div className="flex-1 min-h-0 bg-muted/20">
            <PieChartCanvas data={data} height="fill" mode="expanded" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
